<template>
    <div class="v-input-wrapper">
        <button class="v-input-button" @click="$emit('decrement')">-</button>
        <input type="number" min="1" :value="value" @keyup="$emit('keyup', $event.target.value)">
        <button class="v-input-button" @click="$emit('increment')">+</button>
        <button v-if="removable" class="v-input-button" @click="$emit('remove')">
            <span class="removable-x">x</span>
        </button>
    </div>
</template>

<script>
export default {
    name: ``,
    props: {
        value: { required: false, type: Number, default: 0 },
        removable: { required: false, type: Boolean, default: false }
    },
    data: () => ({})
}
</script>

<style lang="scss" scoped>
    .v-input-wrapper {
        display: flex;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: hidden;
        flex-direction: row;
        justify-content: space-between;

        .v-input-button, input {
            border: none;
            flex-grow: 1;
        }

        .v-input-button {
            padding: 6px;
            background: #ddd;
        }

        input {
            text-align: center;
            max-width: 50px;
        }
    }

    .removable-x {
        color: red;
        font-weight: bold;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance:textfield;
    }
</style>
